export default __webpack_public_path__ + "static/media/BookDefault.c2dd61d8.jpg";